import { render, staticRenderFns } from "./tab-news.vue?vue&type=template&id=88c7b31a&scoped=true&"
import script from "./tab-news.vue?vue&type=script&lang=js&"
export * from "./tab-news.vue?vue&type=script&lang=js&"
import style0 from "./tab-news.vue?vue&type=style&index=0&id=88c7b31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7b31a",
  null
  
)

export default component.exports